import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GuideTheme } from './guideIndex';

const VISIBLE = 3;

// Un thème de guides : les 3 premiers, puis « Voir plus » pour déplier le reste.
// Tous les liens restent dans la page (pré-rendu, robots) ; seuls les suivants sont masqués.
const ThemeGuides: React.FC<{ theme: GuideTheme; showText?: boolean; open?: boolean }> = ({
  theme,
  showText = true,
  open = false,
}) => {
  const [expanded, setExpanded] = useState(open);
  const hiddenCount = theme.items.length - VISIBLE;
  return (
    <section id={theme.id} className="mg-related" aria-labelledby={`${theme.id}-title`}>
      <h2 id={`${theme.id}-title`}>{theme.title}</h2>
      {showText && <p className="mg-theme-text">{theme.text}</p>}
      <div className="mg-related-grid" id={`${theme.id}-list`}>
        {theme.items.map((g, i) => (
          <Link key={g.to} to={g.to} className="mg-related-card" hidden={!expanded && i >= VISIBLE}>
            <b>{g.title}</b>
            <span>{g.text}</span>
            <span className="mg-related-more" aria-hidden="true">
              {g.tool ? 'Utiliser →' : 'Lire →'}
            </span>
          </Link>
        ))}
      </div>
      {hiddenCount > 0 && (
        <button
          type="button"
          className="mg-more-btn"
          aria-expanded={expanded}
          aria-controls={`${theme.id}-list`}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Voir moins' : `Voir les ${theme.items.length} guides « ${theme.title} »`}{' '}
          <span aria-hidden="true">{expanded ? '↑' : '→'}</span>
        </button>
      )}
    </section>
  );
};

export default ThemeGuides;
